// alertasComun.js — Lo que comparten la campana (CampanaAlertas) y la página /alertas:
// nombre, color e ícono de cada tipo de alerta, y la fecha relativa.
import React from 'react';

const P = { fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true };
const svg = (hijos) => <svg width="18" height="18" viewBox="0 0 24 24" {...P}>{hijos}</svg>;

export const TIPOS = {
  leccion: { nombre: 'Lecciones', color: '#22c39a', icono: svg(<><path d="M20 6 9 17l-5-5" /></>) },
  modulo: { nombre: 'Módulos', color: '#22c39a', icono: svg(<><path d="M4 22V4a1 1 0 0 1 1-1h10l-2 4 2 4H5" /></>) },
  avance: { nombre: 'Avance', color: '#3ba7ff', icono: svg(<><path d="M3 17l6-6 4 4 8-8" /><path d="M14 7h7v7" /></>) },
  evaluacion: { nombre: 'Evaluaciones', color: '#a78bfa', icono: svg(<><path d="M9 11l3 3L22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></>) },
  certificado: { nombre: 'Certificados', color: '#f5b83d', icono: svg(<><circle cx="12" cy="9" r="6" /><path d="M8.5 14 7 22l5-3 5 3-1.5-8" /></>) },
  suscripcion: { nombre: 'Suscripción', color: '#ff7a59', icono: svg(<><rect x="2" y="5" width="20" height="14" rx="2" /><path d="M2 10h20" /></>) },
  aviso: { nombre: 'Avisos', color: '#38bdf8', icono: svg(<><path d="M3 11v2a1 1 0 0 0 1 1h3l5 4V6L7 10H4a1 1 0 0 0-1 1z" /><path d="M16 9a3 3 0 0 1 0 6" /></>) },
  recordatorio: { nombre: 'Recordatorios', color: '#f59e0b', icono: svg(<><circle cx="12" cy="13" r="8" /><path d="M12 9v4l2 2M5 3 2 6M22 6l-3-3" /></>) },
  bienvenida: { nombre: 'Bienvenida', color: '#94a3b8', icono: svg(<><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" /></>) },
};
export const tipoDe = (t) => TIPOS[t] || TIPOS.aviso;

export const IcoCampana = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" {...P} {...props}>
    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
  </svg>
);

// Chincheta de las alertas fijadas por el proyecto.
export const IcoPin = (props) => (
  <svg width="13" height="13" viewBox="0 0 24 24" {...P} {...props}>
    <path d="M12 17v5" /><path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z" />
  </svg>
);

// La base guarda UTC.
const aFecha = (f) => new Date(String(f).replace(' ', 'T') + 'Z');
export const hace = (f) => {
  if (!f) return '';
  const s = Math.max(0, (Date.now() - aFecha(f)) / 1000);
  if (s < 60) return 'ahora';
  if (s < 3600) return `hace ${Math.floor(s / 60)} min`;
  if (s < 86400) return `hace ${Math.floor(s / 3600)} h`;
  const d = Math.floor(s / 86400);
  if (d === 1) return 'ayer';
  if (d < 7) return `hace ${d} días`;
  return aFecha(f).toLocaleDateString('es-CO', { day: 'numeric', month: 'short', timeZone: 'America/Bogota' });
};
export const diaDe = (f) => {
  const fecha = aFecha(f);
  const clave = (x) => x.toLocaleDateString('es-CO', { timeZone: 'America/Bogota' });
  const hoy = new Date(); const ayer = new Date(Date.now() - 86400000);
  if (clave(fecha) === clave(hoy)) return 'Hoy';
  if (clave(fecha) === clave(ayer)) return 'Ayer';
  const t = fecha.toLocaleDateString('es-CO', { weekday: 'long', day: 'numeric', month: 'long', year: fecha.getFullYear() !== hoy.getFullYear() ? 'numeric' : undefined, timeZone: 'America/Bogota' });
  return t.charAt(0).toUpperCase() + t.slice(1);
};
export const horaDe = (f) => aFecha(f).toLocaleTimeString('es-CO', { hour: 'numeric', minute: '2-digit', timeZone: 'America/Bogota' });
// Enlaces internos se navegan sin recargar; los externos abren pestaña nueva.
export const esExterno = (u) => /^https?:\/\//.test(u || '') && !(u || '').startsWith(window.location.origin);
